module.exports = __webpack_public_path__ + "static/media/image_2.d5bc0d25.jpg";